<template>
  <div class="modal fade" id="editTemplateModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog w-75">
      <div class="modal-content p-4">
        <div class="modal-header border-0 pb-2">
          <h4 class="modal-title font-weight-bold text-secondary w-100">
            Vorlage
            <span v-if="isEdit"> {{$t('edit')}} </span>
            <span v-else> importieren </span>

              <button  type="button" v-if="!isEdit" @click="isEdit = true" class="arrows-btns float-right add-group-btn m-0 d-inline-block" style="padding: 5px 13px">
                <i class="fa fa-edit mr-1" aria-hidden="true"></i>
                Vorlage {{$t('edit')}}
              </button>
          </h4>
          <button v-if="isEdit" type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <form v-on:submit.prevent="saveTemplate">
          <div class="modal-body pt-0">
            <div class="card">
              <div class="row">
                <div class="col-md-3 border-right px-2">
                  <ul class="template-list ml-2 mr-1 mt-2 pl-1 pt-2">
                    <li @click="groupParams(template,$event); editIndex = index" :class="{'active': editIndex === index && editTem === null,'edit-tem p-0': editTem === index }" v-for="(template, index) in templates" :key="index">
                      <div data-value="btn" class="form-group rounded shadow-sm text-right py-3 px-2 border" v-if="editTem === index">
                        <input id="templateNewName" placeholder="Vorlagename" data-value="btn" type="text" class="form-control form-control-sm font-weight-bold" :value="template.name" autofocus="autofocus" style="color: gray">
                        <button data-value="btn" type="button" class="btn-sm mb-2 btn-secondary d-inline-block mr-1 mt-2" @click="editTem = null">{{$t('cancel')}}</button>
                        <button data-value="btn" type="button" class="btn-sm mb-2 btn-success mt-2" @click="updateTemplateName(template)" :disabled="loading">
                         <i v-if="loading" class="spinner-border-sm spinner-border mr-1" style="margin-bottom: 1px"></i> {{$t('save')}}
                        </button>
                      </div>
                      <span v-else class="pl-2">{{template.name || 'no_name'}}</span>
                      <div class="float-right icons" v-if="isEdit">
                        <button data-value="btn" type="button" class="d-inline-block text-white px-1" @click="editTem = index">
                          <i data-value="btn" class="fa fa-edit pr-1"></i>
                        </button>
                        <button data-value="btn" type="button" class="d-inline-block text-white px-1" @click="deleteTemplate(index)">
                          <i data-value="btn" class="fa fa-trash-alt"></i>
                        </button>
                      </div>
                    </li>
                  </ul>
                </div>
                <div class="col-md-9">
                  <div class="inrbox pb-1 screen-height catch-words pl-0">
                      <table class="table table-sm">
                        <thead>
                        <tr>
                          <th scope="col">
                            <div class="pl-1"> Schlagwortgruppe</div>
                          </th>
                          <th scope="col">Schlagwort</th>
                          <th scope="col">Typ</th>
                          <th scope="col" v-if="!isEdit"><span v-visible="false"> no visible </span></th>
                          <th scope="col">
                            <span class="d-none"></span>
                          </th>
                        </tr>
                        </thead>
                        <tbody v-for="(group, i) in templateGroups" :key="i" class="border-0">
                        <tr v-if="!isEdit && i === 0">
                          <td>
                            <div class="font-weight-bold checkbox-group custom-control custom-checkbox">
                              <input @change="selectAllTag" :checked="selectedCopy.length === selectedParams.length" type="checkbox" id="all_active" class="custom-control-input mt-1">
                              <label data-value="btn" for="all_active" class="custom-control-label custom-label">Alle aktivieren/deaktivieren</label>
                            </div>
                          </td>
                        </tr>
                        <tr  :class="{active_tr: activeGroup === i}" data-value="btn">
                          <td colspan="3">
                            <div class="form-row ml-4">
                              <div v-if="!isEdit" class="checkbox-group ml-4 pl-3 custom-control custom-checkbox">
                                <input type="checkbox" :checked="isGroupSelected(group)" @change="handleGroup($event,i)" :id="`group${i}`" class="custom-control-input mt-1">
                                <label class="custom-control-label custom-label" :for="`group${i}`"></label>
                              </div>
                              <div class="custom-control pl-0 mt-1 custom-checkbox circle-checkbox d-inline" data-value="btn">
                                <input type="text" :value="group.groupName" @change="changeGroupName($event, i)" class="group-input form-control input-style" v-if="activeGroup === i || (group.items && group.items[0].isNew)" placeholder="Schlagwortgruppenname" data-value="btn" required autofocus>
                                <input v-else type="text" :value="group.groupName" @change="changeGroupName($event, i)" class="group-input form-control input-style bg-white border-0" placeholder="Schlagwortgruppenname"  readonly>
                              </div>
                            </div>
                          </td>
                          <td v-if="isEdit">
<!--                            v-visible="i === activeGroup"-->
                            <div class="udarrow mr-0"  style="width: 4.5rem">
                              <div @click="moveGroupUp(i)" data-value="btn" class="d-inline-block arrows-btns" v-if="i">
                                <i class="fa fa-angle-up"></i>
                              </div>
                              <div @click="moveGroupDown(i)" data-value="btn" class="d-inline-block arrows-btns" v-if="templateGroups.length !== (i + 1)">
                                <i class="fa fa-angle-down"></i>
                              </div>
                            </div>
                          </td>
                        </tr>

                        <tr v-for="(keyword , index) in group.items" :key="keyword.projectparamid" :class="{active_tr : `${index}${i}` === activeItem}" @click="makeFieldsEditable($event,`${index}${i}`)">
                          <th scope="row">
                            <!--                    {{ keyword.order }}-->
                          </th>
                          <td>
                            <div class="form-row">
                              <div class="col-auto" v-if="!isEdit">
                                <div class="checkbox-group custom-control custom-checkbox">
                                  <input :value="keyword.order" type="checkbox" v-model="selectedParams" :id="`keyword${index}${i}`" class="custom-control-input mt-1">
                                  <label data-value="btn" :for="`keyword${index}${i}`" class="custom-control-label custom-label"></label>
                                </div>
                              </div>
                              <div class="col-auto">
                                <input type="text" v-if="`${index}${i}` === activeItem" v-model="keyword.name" class="form-control input-style" data-value="btn" required>
                                <input type="text" v-else v-model="keyword.name" class="form-control input-style" :class="{'mt-1': !isEdit}" readonly required>
                              </div>
                            </div>
                          </td>
                          <td>
                            <div class="form-row justify-content-center">
                              <div class="switch-toggle switch-3 switch-candy" data-value="btn" v-if="isEdit">
                                <input data-value="btn" :id="`ond${index}${i}`" :name="`state-d${index}${i}`" type="radio" v-model="keyword.type" value="0"/>
                                <label data-value="btn" :for="`ond${index}${i}`" class="arrows-btns">
                                  <i class="fa fa-check" aria-hidden="true" data-value="btn"></i>
                                </label>
                                <input :id="`of${index}${i}`" :name="`state-d${index}${i}`" v-model="keyword.type" value="1" data-value="btn" type="radio"/>
                                <label data-value="btn" class="arrows-btns btn-abc" :for="`of${index}${i}`">ABC</label>
                              </div>
                              <div class="switch-toggle shadow-sm switch-3 switch-candy" data-value="btn" v-else>
                                <label data-value="btn" class="arrows-btns btn-abc mb-0">
                                  <span v-if="keyword.type == '1'">ABC</span>
                                  <i v-else class="fa fa-check-square-o" aria-hidden="true" data-value="btn"></i>
                                </label>
                              </div>
                            </div>
                          </td>
                          <td v-if="isEdit">
<!--                            v-visible="`${index}${i}` === activeItem"-->
                            <div class="udarrow mr-0"  style="width: 4.5rem">
                              <button type="button" @click="moveUp(keyword.projectparamid , index,i)" :disabled="index === 0" data-value="btn" class="d-inline-block arrows-btns">
                                <i class="fa fa-angle-up" data-value="btn"></i>
                              </button>
<!--                              group.items.length !== (index + 1) put v-if at the place of disabled -->
                              <button type="button" @click="moveDown(keyword.projectparamid ,index , i)" :disabled="group.items.length == (index + 1)" data-value="btn" class="d-inline-block arrows-btns">
                                <i class="fa fa-angle-down" data-value="btn"></i>
                              </button>
                            </div>
<!--                            v-visible="`${index}${i}` === activeItem"-->
                            <span class="text-light">|</span>
                            <a @click="removeKeyword(keyword.projectparamid, i , index)" class="ml-1 d-inline-block arrows-btns" data-value="btn">
                              <i class="fa fa-trash-alt" data-value="btn"></i>
                            </a>
                          </td>
                        </tr>
                        <tr  v-if="isEdit">
                          <td></td>
                          <td colspan="3" class="text-left">
                            <button type="button" class="arrows-btns add-group-btn" @click="addNewFieldInTagsGroup(group.groupName , i)">
                              <i class="fa fa-plus pr-1" aria-hidden="true"></i>
                              Feld hinzufügen
                            </button>
                          </td>
                        </tr>
                        </tbody>
                        <tfoot>
                        <tr v-if="isEdit">
                          <td colspan="2" class="text-left">
                            <button type="button" class="arrows-btns add-group-btn mt-1" @click="addNewGroup">
                              <i class="fa fa-plus pr-1" aria-hidden="true"></i>
                              Gruppe hinzufügen
                            </button>
                          </td>
                        </tr>
                        </tfoot>
                      </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer border-0 pt-2">
            <div class="dokubtns text-right border-0 p-0 m-0">
            <span class="btninner">
              <button type="button" @click.prevent="cancelModal" class="btn btn-red" >
               {{ $t('cancel') }}
              </button>

              <button type="submit" class="btn btn-blue" :disabled="loading" v-if="!isEdit">
               <i v-if="loading" class="mr-1 spinner-border spinner-border-sm" style="margin-bottom: 2px"></i> {{ $t('Import') }}
              </button>
              <button type="submit" class="btn btn-blue" :disabled="loading" v-if="isEdit">
               <i v-if="loading" class="mr-1 spinner-border spinner-border-sm" style="margin-bottom: 2px"></i> {{ $t('save') }}
              </button>
            </span>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import axios from "axios";
import axios from "../../../utils/axiosinstance";

export default {
  props: ['params','is_import'],
  data () {
    return {
      templateName: '',
      editIndex: 0,
      loading: false,
      isEdit: false,
      editTem: null,
      activeTr: null,
      activeGroup: null,
      selectedParams: [],
      selectedCopy: [],
      selectedTemplateParams: [],
      activeItem: null,
      templateId: null,
      groupCount: 0,
      templateGroups: []
    }
  },
  computed: {
    templates(){
      return this.$store.state.appSettings.userTemplates
    },
    project () {
      return this.$store.state.appSettings.project
    },
    userId () {
      return this.$store.state.projects.user.pduserid
    }
  },
  mounted() {
    const _this = this;
    $('#editTemplateModal').on('shown.bs.modal', () => {
      if (_this.templates && _this.templates.length > 0){
        _this.activeGroup = _this.activeItem = null;
        _this.editIndex = 0
        _this.groupParams(_this.templates[0]);
        _this.isEdit = false;
      }
    });
  },
  methods: {
    cancelModal(){
      if (this.isEdit){
        this.isEdit = false
      }else {
        $('#editTemplateModal').modal('toggle');
      }
    },
    isGroupSelected(group) {
      return group.items.some(item => this.selectedParams.includes(item.order));
    },
    handleGroup(event, index) {
      const groupItems = this.templateGroups[index].items;
      if (event.target.checked) {
        groupItems.forEach(item => {
          if (!this.selectedParams.includes(item)){
            this.selectedParams.push(item.order)
          }
        });
      } else {
        const ordersToRemove = new Set(groupItems.map(item => item.order));
        this.selectedParams = this.selectedParams.filter(order => !ordersToRemove.has(order));
      }
    },
    groupByGroupWithStructure(items) {
      const tempGroups = items.reduce((acc, item) => {
        if (!acc[item.group]) {
          acc[item.group] = [];
        }
        acc[item.group].push(item);
        return acc;
      }, {});
      // Convert the temporary object into the desired array structure
      return Object.keys(tempGroups).map(groupName => ({
        groupName: groupName,
        items: tempGroups[groupName]
      }));
    },
    groupParams(template,e = null){
      if (e === null || (e && e.target.getAttribute('data-value') != 'btn')){
        this.editTem = null
        this.templateId = template.projecttemplateid
        this.templateName = template.name
        template.params.forEach((item,index) => item.order = (index + 1))
        this.selectedTemplateParams = template.params;
        const params = JSON.parse(JSON.stringify(template.params))
        this.selectedParams = params.map(pr => pr.order);
        this.selectedCopy = JSON.parse(JSON.stringify(this.selectedParams));
        this.templateGroups = this.groupByGroupWithStructure(params);
      }
    },
    selectAllTag(event){
      if (event.target.checked) {
        this.selectedParams = JSON.parse(JSON.stringify(this.selectedCopy));
      }else {
        this.selectedParams = []
      }
    },

    async deleteTemplate(index){
      const _this = this
      this.$confirm({
        message: "Vorlage löschen?",
        button: {
          no: 'Abbrechen',
          yes: 'Ja'
        }, callback: confirm => {
          if (confirm) {
            _this.deleteTemplateByIndex(index);
          }
        }
      });
    },

    async deleteTemplateByIndex(index){
      this.loading = true
      const id = this.templates[index].projecttemplateid
      this.$store.commit('settingsModuleSetLoading',true);
      const is_deleted = await this.$store.dispatch('deleteTemplate', id);
      const _this = this
      if (is_deleted){
        await this.$store.dispatch('getSettingsTemplatesByUser',_this.project.customer_id);
        _this.$toast.success('Vorlage gelöscht');
        if (_this.templates[index + 1]){
          _this.groupParams(_this.templates[index + 1])
        }else if (_this.templates[0]){
          _this.editIndex = 0;
          _this.groupParams(_this.templates[0])
        }
        _this.$store.commit('settingsModuleSetLoading',false);
      }
      this.loading = false;
    },

    async saveProjectDetails () {
      const params = this.selectedTemplateParams.filter(item => this.selectedParams.includes(item.order))

      console.log('Import', this.project.params, params)

      const project_params = this.getUniqueArray([...this.project.params,...params])

      console.log('Import B', params, project_params)

      await this.$store.commit('setProjectParams', project_params);
      this.$toast.success('Vorlage erfolgreich implementiert');
      $('#editTemplateModal').modal('toggle');
    },

    getUniqueArray(array) {
      // Filter out items with null or empty names
      const validItems = array.filter(item => item.name && item.name.trim() !== '');
      const uniqueItems = [];
      const seenNamesInGroups = {};
      let order = 1;
      validItems.forEach(item => {
        if (!seenNamesInGroups[item.group]) {
          seenNamesInGroups[item.group] = new Set();
        }
        console.log('validItems.each', item.group, item.name, item, validItems, array)
        const itemNameLower = item.name.toLowerCase();
        if (!seenNamesInGroups[item.group].has(itemNameLower)) {
          seenNamesInGroups[item.group].add(itemNameLower);
          item.order = order++;
          uniqueItems.push(item);
        }
      });
      return uniqueItems;
    },


    async saveTemplate(){
      this.loading = true
      if (!this.isEdit){
        // in case of import keywords
        await this.saveProjectDetails();
        this.loading = false;
        return;
      }
      this.$store.commit('settingsModuleSetLoading',true);
      let user_id = this.project.customer_id

      let paramdata = []
      let count = 0
      this.templateGroups.forEach(group => {
        group.items.forEach(item => {
          if (item.projectparamid && item.projectparamid.startsWith('new')) {
            delete item.projectparamid
          }
          item.order = ++count
          paramdata.push(item)
        })
      });
      const project_params = this.getUniqueArray(paramdata)
      const data = {
        projecttemplateid: this.templateId,
        customer_id: user_id,
        dailydocutype: this.project.dailydocu,
        is_default: 0,
        name: this.templateName,
        params: project_params,
        photoquality: this.project.photoquality,
        _explicitType: "com\\projectdocu\\ProjectTemplateVO"
      }
      await this.$store.dispatch('saveSettingsTemplate', [ data ])
      await this.$store.dispatch('getSettingsTemplatesByUser',  user_id )
      this.$store.commit('settingsModuleSetLoading',false);
      this.loading = false;
      if (!this.isEdit){
        $('#editTemplateModal').modal('toggle');
      }else {
         this.isEdit = false;
        this.activeGroup = this.activeTr = null;
      }
    },

    async updateTemplateName(template){
      this.loading = true
      const user_id = this.project.customer_id
      const name = document.getElementById('templateNewName').value;
      const data = {
        projecttemplateid: template.projecttemplateid,
        customer_id: user_id,
        dailydocutype: this.project.dailydocu,
        is_default: 0,
        name: name,
        params: template.params,
        photoquality: this.project.photoquality,
        _explicitType: "com\\projectdocu\\ProjectTemplateVO"
      }
      await this.$store.dispatch('saveSettingsTemplate', [ data ])
      await this.$store.dispatch('getSettingsTemplatesByUser',  user_id )
      this.$store.commit('settingsModuleSetLoading',false);
      this.loading = false;
      this.editTem = null
    },

    async  deleteGroupItem(id){
      await axios.post(`${process.env.VUE_APP_BASE_AMF_URL}&token=${localStorage.sessiontoken}`,
        {
          "methodName": "deleteProjectparam",
          "parameters": [id],
          "serviceName": "ProjectdocuService"
        },
        {
          headers: {
            apitoken: localStorage.apikey,
            deviceid: localStorage.deviceid,
            accept: 'application/json'
          }
        }).then(res => {
        console.log(res,"response")
      })
    },

    /** On click on a row make it editable
     *
     * @param e
     * @param index
     */
    makeFieldsEditable (e, index) {
      if (this.isEdit){
        const element = e.target.getAttribute('data-value')
        if (element !== 'btn' && e.target.tagName !== 'IMG') {
          this.activeItem = this.activeItem === index ? null : index
          this.activeGroup = null
        }
      }
    },

    //On click a table row make it group name editable
    makeGroupEditable (e, index) {
      let element = e.target.getAttribute('data-value')
      let tag = e.target.tagName
      if ((element !== 'btn' && tag !== 'IMG')) {
        this.activeGroup = this.activeGroup === index ? null : index
        this.activeTr = null
      }
    },


    // Move the Keyword field Up one step by clicking the Up arrow
    moveUp (id, index, i) {
      let from = index
      let to = from - 1
      const elm = this.templateGroups[i].items.splice(from, 1)[0]
      this.templateGroups[i].items.splice(to, 0, elm)
      this.activeItem = `${index - 1}${i}`
    },

    /**Move the Keyword field down by clicking the down arrow
     *
     * @param id
     * @param index
     * @param i
     */
    moveDown (id, index, i) {
      let from = index
      let to = from + 1
      const elm = this.templateGroups[i].items.splice(from, 1)[0]
      this.templateGroups[i].items.splice(to, 0, elm)
      this.activeItem = `${index + 1}${i}`
    },

     moveGroupUp (from) {
      let to = from - 1
      const elm = this.templateGroups.splice(from, 1)[0]
      this.templateGroups.splice(to, 0, elm)
      this.activeGroup = from - 1
    },

    moveGroupDown (from) {
      let to = from + 1
      const elm = this.templateGroups.splice(from, 1)[0]
      this.templateGroups.splice(to, 0, elm)
      this.activeGroup = to
    },


    //function to remove Group item
    async removeKeyword (id , i , index) {
      let _this = this
      if (id && id.startsWith('new')){
        this.templateGroups[i].items.length  === 1 ? this.templateGroups.splice(i, 1) :this.templateGroups[i].items.splice(index, 1);
      }else {
        _this.$confirm({
          message: "Schlagwort löschen?",
          button: {
            no: 'Abbrechen',
            yes: 'Ja'
          }, callback: confirm => {
            if (confirm) {
              _this.$store.commit('settingsModuleSetLoading',true);
              _this.deleteGroupItem(id);
              _this.templateGroups[i].items.length  === 1 ? _this.templateGroups.splice(i, 1) : _this.templateGroups[i].items.splice(index, 1);
              _this.$store.commit('settingsModuleSetLoading',false);
              _this.$toast.success("Schlagwort gelöscht");
            }
          }
        });
      }
    },

    addNewFieldInTagsGroup (groupName , i) {
      let id = this.$route.params.id
      let newField =
        {
          group: groupName,
          isUsed: null,
          name: '',
          projectparamid: `new${Math.random()}`,
          order: '0',
          paramType: 'project',
          projectid: id,
          type: '0',
          value: null,
          visible: '0',
          _explicitType: 'com\\projectdocu\\ProjectparamVO'
        }
      this.templateGroups[i].items.push(newField)
    },

    /**On Change Group Name
     *
     * @param e
     * @param index
     */
    changeGroupName (e, index) {
      let value = e.target.value
      this.templateGroups[index].items.forEach(item => {
        item.group = value
      })
      this.templateGroups[index].groupName = value
    },

    /**
     * Add New Group
     */
    addNewGroup () {
      let id = this.$route.params.id
      let name = ''
      if (this.groupCount === 0){ this.activeGroup = this.templateGroups.length }
      let newGroup = {
        groupName: name,
        items: [{
          group: name,
          isUsed: null,
          name: '',
          isNew: true,
          order: '0',
          projectparamid: `new${Math.random()}`,
          paramType: 'project',
          projectid: id,
          type: '0',
          value: null,
          visible: '0',
          _explicitType: 'com\\projectdocu\\ProjectparamVO'
        }]
      }
      this.templateGroups.push(newGroup)
      this.groupCount++
    }
  }
}
</script>

<style scoped>
.template-list{
  color: #707070;
  font-size: 16px;
}
.template-list li{
  border-radius: 9px;
  margin-bottom: 5px;
  cursor: pointer;
  padding: 4px;
}
.template-list button{
  cursor: pointer;
}
.template-list li.active{
  color: #FFFFFF;
  background-color: #007bff;
}
.template-list li:not(.edit-tem):hover {
  color: #FFFFFF;
  background-color: #007bff;
}
.template-list li .icons{
  display: none;
}
.template-list li.active .icons{
  display: inline-block;
}
 .active_tr {
   background: lightgray;
 }
input.group-input {
  border: 1px solid #ccc;
  padding: 4px;
  width: 100%;
  border-radius: 3px;
  font-weight: bold;
}

.btnw, .udarrow small, .udrem {
  cursor: pointer;
  z-index: 1000;
  font-size: 1rem;
}

.switch-toggle input {
  width: fit-content;
}

.main-tabs .table-sm td {
  padding-top: 4px;
}

.switch-toggle input + label {
  z-index: 1000;
}

.switch-toggle input[type="radio"] + label {
  background: #ffffff;
}

.switch-toggle input[type="radio"]:checked + label {
  background: #3f97ef;
}

.circle-checkbox .custom-control-label {
  position: absolute;
}

button.btn-primary:hover {
  color: #3f97ef !important;
}
.inrbox.catch-words{
  height: calc(100vh - 249px);
}
.arrows-btns{
  color: gray;
  border-radius: 5px;
  margin-top: 2px;
  background-color: #FFFFFF;
  border: 1px solid #dcdcdc;
  padding: 1px 8px;
  font-size: 15px;
  cursor: pointer;
  z-index: 99;
}
.btn-abc{
  padding: 4px 13px;
  font-size: 12px;
  font-weight: 600;
}
.add-group-btn{
  margin: 4px 0 4px 9px;
  padding: 3px 8px;
  font-size: 15px;
  font-weight: bold;
}
.checkbox-group {
  margin-left: 7px;
  margin-right: -7px;
  margin-top: 5px;
  font-family: Arial, sans-serif;
}
.checkbox-custom {
  display: none;
}
.checkbox-custom + label {
  position: relative;
  padding-left: 25px;
  cursor: pointer;
}
.checkbox-custom + label:before {
  content: '';
  position: absolute;
  left: 0;
  top: 0;
  width: 18px;
  height: 18px;
  border: 1px solid #000;
  border-radius: 3px;
  background-color: #fff;
}
.checkbox-custom:checked + label:before {
  background-color: #007bff;
}
.checkbox-custom:checked + label:after {
  content: '✔';
  position: absolute;
  left: 4px;
  top: -1px;
  color: white;
}
.catch-words .custom-checkbox .custom-control-input:checked~.custom-control-label::after {
  margin-left: 1px;
}
</style>



// WEBPACK FOOTER //
// src/components/appSetting/components/EditTemplateModal.vue